import { CARRIER_SHIPMENT_PROGRESS_STATUS_PRIORITY } from "constants/index";

export function getShipmentDetailTableTitle(
  shipment: CondensedShipment,
  progress: ShipmentProgress,
) {
  if (shipment.is_private) {
    return `${progress.notified_network_carrier_count} Partners Notified • ${progress.view_count} Views • ${progress.no_capacity_count} No truck available • ${progress.quote_count} Quotes`;
  }
  if (progress.lane_match_count === 0) {
    return `Matches Loading.. • ${progress.notified_network_carrier_count} Partners Notified • ${progress.view_count} Views • ${progress.no_capacity_count} No truck available • ${progress.quote_count} Quotes`;
  }
  return `${progress.lane_match_count} Matches • ${progress.notified_network_carrier_count} Partners Notified • ${progress.view_count} Views • ${progress.no_capacity_count} No truck available • ${progress.quote_count} Quotes`;
}

export function sortByCarrierShipmentProgressStatus(
  carrierProgress: CarrierShipmentProgress[],
): CarrierShipmentProgress[] {
  return [...carrierProgress].sort(
    (a, b) =>
      CARRIER_SHIPMENT_PROGRESS_STATUS_PRIORITY[a.status] -
      CARRIER_SHIPMENT_PROGRESS_STATUS_PRIORITY[b.status],
  );
}
